module.exports = __webpack_public_path__ + "static/media/26UNRWA22.cb183779.jpg";